import { Map, fromJS } from 'immutable'
import { actions } from './actions'

const initialState = Map({
    userProfile: null,
    creatingUserProfile: false,
    createUserProfileSuccess: false,
    createUserProfileError: null,
    getUserProfileResponse: null,
    syncingProfile: false,
    noContactDropOff: false,
    updatingUserProfile: false,
    updateUserProfileError: null,
    updateProfileErrorField: null,
    updateProfileErrorMessage: null,
    updateProfileSuccess: false,
    needAgeVerification: false,
    isNeedAgeVerification: false,
    isAgeVerificationError: false,
    getUserProfileErrorResponse: null,
    fetchingReferralCode: false,
    referralCodeError: false,
    referralCode: null,
    currentSingleCreditValue: null,
    totalAvailableCredits: null,
    totalAvailableCreditValue: null,
    countryCredits: null,
    faqs: null,
    ageVerificationErrorMsg: null,
    showOTPScreen: false,
    otpData: null,
    hasAcknowledgedCateringFtue: false,
})
const user = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actions.REGISTER_USER_ACCOUNT: {
            return state.merge({
                creatingUserProfile: true,
                createUserProfileError: null,
            })
        }

        case actions.REGISTER_USER_ACCOUNT_SUCCESS: {
            return state.merge({
                creatingUserProfile: false,
                createUserProfileSuccess: true,
                createUserProfileError: null,
            })
        }

        case actions.RESET_REGISTER_USER_ACCOUNT_SUCCESS: {
            return state.merge({
                createUserProfileSuccess: false,
            })
        }

        case actions.REGISTER_USER_ACCOUNT_FAILED: {
            return state.merge({
                creatingUserProfile: false,
                createUserProfileSuccess: false,
                createUserProfileError: fromJS(payload),
            })
        }
        case actions.GET_USER_PROFILE_SUCCESS: {
            return state.merge({
                getUserProfileResponse: fromJS(payload),
            })
        }

        case actions.OTP_GENERATE_SUCCESS_REGISTER: {
            return state.merge({
                showOTPScreen: payload.success,
                otpData: payload.data,
            })
        }

        case actions.GET_USER_PROFILE_FAILED: {
            return state.merge({
                userProfile: null,
                getUserProfileErrorResponse: fromJS(payload),
            })
        }

        case actions.SYNCING_USER_PROFILE: {
            return state.merge({
                syncingProfile: payload,
            })
        }

        case actions.GET_FB_USER_PROFILE: {
            return state.merge({
                gettingFbUserProfile: true,
                fbUserProfile: null,
                getfbUserProfileError: null,
            })
        }

        case actions.GET_FB_USER_PROFILE_SUCCESS: {
            return state.merge({
                gettingFbUserProfile: false,
                fbUserProfile: fromJS(payload),
            })
        }

        case actions.GET_FB_USER_PROFILE_FAILED: {
            return state.merge({
                gettingFbUserProfile: false,
                getfbUserProfileError: fromJS(payload),
            })
        }
        case actions.SET_USER_PROFILE: {
            return state.merge({
                userProfile: fromJS(payload),
                hasAcknowledgedCateringFtue: payload.has_acknowledged_catering_ftue === true,
            })
        }

        case actions.CLEAR_FORM_ERRORS: {
            return state.merge({
                createUserProfileError: null,
            })
        }

        case actions.SET_NO_CONTACT_DROP_OFF: {
            return state.merge({
                noContactDropOff: payload,
            })
        }

        case actions.RESET_USER: {
            return state.merge({
                userProfile: null,
                creatingUserProfile: false,
                createUserProfileError: null,
                getUserProfileResponse: null,
                noContactDropOff: false,
                isNeedAgeVerification: false,
            })
        }

        case actions.UPDATE_USER_PROFILE: {
            return state.merge({
                updatingUserProfile: true,
                updatingUserProfileError: null,
                updateProfileSuccess: false,
                updateProfileErrorField: null,
                updateProfileErrorMessage: null,
            })
        }

        case actions.UPDATE_USER_PROFILE_FAILED: {
            return state.merge({
                updatingUserProfile: false,
                updateUserProfileError: fromJS(payload.message),
                updateProfileSuccess: false,
                updateProfileErrorField: true,
                updateProfileErrorMessage: fromJS(payload.message),
            })
        }

        case actions.UPDATE_USER_PROFILE_SUCCESS: {
            const userProfile = state.get('userProfile').merge({
                first_name: payload.first_name,
                last_name: payload.last_name,
                phone_number: JSON.stringify(payload.phone_number),
                email: payload.email,
            })

            return state.merge({
                updatingUserProfile: false,
                userProfile,
                updateProfileSuccess: true,
                updateProfileErrorField: null,
                updateProfileErrorMessage: null,
                hasAcknowledgedCateringFtue: payload.has_acknowledged_catering_ftue === true,
            })
            // }
        }

        case actions.RESET_UPDATE_PROFILE: {
            return state.merge({
                updatingUserProfile: false,
                updateUserProfileError: null,
                updateProfileErrorField: null,
                updateProfileErrorMessage: null,
                updateProfileSuccess: false,
            })
        }

        case actions.SET_AGE_VERIFICATION: {
            return state.merge({
                needAgeVerification: fromJS(payload),
            })
        }

        case actions.GET_USER_REFERRAL_CODE: {
            return state.merge({
                fetchingReferralCode: true,
                referralCodeError: false,
                referralCode: null,
                currentSingleCreditValue: null,
                totalAvailableCredits: null,
                totalAvailableCreditValue: null,
                countryCredits: null,
                faqs: null,
            })
        }

        case actions.GET_USER_REFERRAL_CODE_SUCCESS: {
            return state.merge({
                fetchingReferralCode: false,
                referralCodeError: false,
                referralCode: payload.referralCode,
                currentSingleCreditValue: payload.currentSingleCreditValue,
                totalAvailableCredits: payload.totalAvailableCredits,
                totalAvailableCreditValue: payload.totalAvailableCreditValue,
                countryCredits: payload.country,
                faqs: payload.faqs,
            })
        }

        case actions.GET_USER_REFERRAL_CODE_FAILURE: {
            return state.merge({
                fetchingReferralCode: false,
                referralCodeError: true,
            })
        }
        case actions.USER_AGE_VERIFICATION_SUCCESS: {
            return state.merge({
                isAgeVerificationError: false,
                isNeedAgeVerification: true,
            })
        }

        case actions.USER_AGE_VERIFICATION_FAILED: {
            return state.merge({
                isAgeVerificationError: true,
                isNeedAgeVerification: false,
                ageVerificationErrorMsg: fromJS(payload.message),
            })
        }

        case actions.SET_AGE_VERIFICATION_FAILED: {
            return state.merge({
                isAgeVerificationError: false,
            })
        }

        default:
            return state
    }
}

export default user
